module.exports = __webpack_public_path__ + "static/media/013.90d06ec4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/013.jpg
// module id = 520
// module chunks = 0